
import { Component, Prop, Vue } from "vue-property-decorator";
import store from "../../core/store";

@Component
export default class TeamCard extends Vue {
  @Prop({ required: true }) private team!: any;
  @Prop({ required: true }) private index!: number;

  private get isDarkMode() {
    return store.state.settings.DarkMode === true;
  }

  getImagePath(img: string) {
    if (img === undefined || img === null || img === "") {
      return store.state.settings.Uploads + "/" + store.state.settings.Mainlogo;
    }
    return store.state.settings.Uploads + "/" + img;
  }
}
